/*
 * Uses all the calculators to calculate the total pay for a given month and year for a given set of shifts
 */

import { Shift } from "../../schema";
import { weekdayPayCalculator } from "./ukWeekdayPayCalculator";
import { weekendPayCalculator } from "./ukWeekendPayCalculator";
import { ShiftData } from "../common";

// Make sure to only pass in shifts that are submitted
export const ukPayCalculator = async (isUKTaxPayer: boolean, shifts: Shift[], month: number, year: number): Promise<ShiftData[]> => {
    const submittedShifts = shifts.filter(shift => shift.submitted);

    const weekdayPay = await weekdayPayCalculator(isUKTaxPayer, submittedShifts, month, year);
    const weekendPay = await weekendPayCalculator(submittedShifts, month, year);

    return [...weekdayPay, ...weekendPay];
}